import LogoutModal from '@/components/LogoutModal';
import { executeLogout } from '@/utils/excuteLogout';
import dynamic from 'next/dynamic';

const DeleteConfirmationModal = dynamic(() => import('../DeleteConfirmationModal'));
const FeedbackModal = dynamic(() => import('../FeedbackModal'));
const VerifyOtpModal = dynamic(() => import('@/components/ActionAuthModal'));

const AllModalContainer = ({
  modalState,
  setModalState,
  onConfirmAccountDelete,
  onSubmitFeedback,
  onOtpVerificationSuccess,
}) => {
  switch (true) {
    case modalState.showConfirmationModal:
      return (
        <DeleteConfirmationModal
          onClose={() =>
            setModalState({
              ...modalState,
              showConfirmationModal: false,
            })
          }
          onConfirmAccountDelete={onConfirmAccountDelete}
        />
      );
    case modalState.showFeedbackModal:
      return (
        <FeedbackModal
          onClose={() =>
            setModalState({
              ...modalState,
              showFeedbackModal: false,
            })
          }
          onSubmitFeedback={onSubmitFeedback}
        />
      );
    case modalState.showVerifyOtpModal:
      return (
        <VerifyOtpModal
          onClose={() =>
            setModalState({
              ...modalState,
              showVerifyOtpModal: false,
            })
          }
          onOtpVerificationSuccess={onOtpVerificationSuccess}
          isCustomerLoggedIn={true}
        />
      );
    case modalState.showLogoutConfirmationModal:
      return (
        <LogoutModal
          toggleLogoutModal={() =>
            setModalState({
              ...modalState,
              showLogoutConfirmationModal: false,
            })
          }
          executeLogout={executeLogout}
          showLogoutConfirmation
        />
      );

    default:
      return null;
  }
};

export default AllModalContainer;
